import React from "react";

export const FeatureSelector = ({ onChange, selected }) => {
  const features = [
    { id: "hero", name: "Hero Section", icon: "🎯" },
    { id: "about", name: "About Us", icon: "📝" },
    { id: "services", name: "Services", icon: "⚡" },
    { id: "portfolio", name: "Portfolio", icon: "🎨" },
    { id: "testimonials", name: "Testimonials", icon: "💬" },
    { id: "contact", name: "Contact Form", icon: "📧" },
    { id: "blog", name: "Blog Section", icon: "📰" },
    { id: "pricing", name: "Pricing Tables", icon: "💰" },
  ];

  return (
    <div className="grid grid-cols-2 gap-2">
      {features.map((feature) => (
        <label
          key={feature.id}
          className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer ${
            selected?.includes(feature.id)
              ? "btnn bg-opacity-20"
              : "bg-[#ffffff0a]"
          }`}
        >
          <input
            type="checkbox"
            className="hidden"
            checked={selected?.includes(feature.id)}
            onChange={(e) => {
              const newSelected = e.target.checked
                ? [...(selected || []), feature.id]
                : (selected || []).filter((id) => id !== feature.id);
              onChange(newSelected);
            }}
          />
          <span className="text-xl">{feature.icon}</span>
          <span className="text-white text-sm">{feature.name}</span>
        </label>
      ))}
    </div>
  );
};
